/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { appendStyleTag } from '../../extensions/custom-styles';

const Edit = ( props ) => {
	const {
		isSelected,
		className,
		attributes,
		setAttributes,
	} = props;
	const { textAlignment, prefixContent, titleContent, suffixContent, prefixColor, titleColor, suffixColor, displayPrefix, displaySuffix, prefixTag, titleTag, suffixTag, blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		`has-text-align-${ textAlignment }`,
		`gutenify-section-${ blockClientId }`,
	);

	return ( <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<BaseWrapper { ...props }>
			{ displayPrefix && <RichText
				tagName={ prefixTag }
				value={ prefixContent }
				onChange={ ( content ) => setAttributes( { prefixContent: content } ) }
				placeholder={ __( 'Title prefix' ) }
				style={ { textAlign: textAlignment, color: prefixColor } }
				onClick={ () => {
					setAttributes( { selectedTitle: 'prefix' } );
				} }
				className="gutenify-section-title-prefix"
			/> }
			<RichText
				tagName={ titleTag }
				value={ titleContent }
				onChange={ ( content ) => setAttributes( { titleContent: content } ) }
				placeholder={ __( 'Title' ) }
				style={ { textAlign: textAlignment, color: titleColor } }
				onClick={ () => {
					setAttributes( { selectedTitle: 'title' } );
				} }
				className="gutenify-section-title-main"
			/>
			{ displaySuffix && <RichText
				tagName={ suffixTag }
				value={ suffixContent }
				onChange={ ( content ) => setAttributes( { suffixContent: content } ) }
				placeholder={ __( 'Title suffix' ) }
				style={ { textAlign: textAlignment, color: suffixColor } }
				onClick={ () => {
					setAttributes( { selectedTitle: 'suffix' } );
				} }
				className="gutenify-section-title-suffix"
			/> }
		</BaseWrapper>
	</div> );
};

export default Edit;
